import { FC, memo } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { RANGE_PRESENT } from './constants';
import { RangeValue } from '../../../hooks/components/useIncomingCalls/types';
import styles from './style.module.css';
import { JournalActionButtons } from '../JournalActionButtons/JournalActionButtons';
import { JournalSearchInput } from './JournalSearchInput';
import {
  ResettableRangePicker,
  ResettableRangeValue,
} from '../../shared/ResettableRangePicker/ResettableRangePicker';

interface Props {
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRangePicker: (values: RangeValue<Dayjs>, formatString: string[]) => void;
  onOkReport: () => void;
  onToggleFilters: () => void;
  isFiltersOpen: boolean;
  isReportLoading?: boolean;
  activeFilterCount?: number;
  dateRange?: ResettableRangeValue;
  disabled?: boolean;
}

export const IncomingCallsTop: FC<Props> = memo(
  ({
    onSearch,
    onRangePicker,
    onOkReport,
    onToggleFilters,
    isFiltersOpen,
    isReportLoading,
    activeFilterCount = 0,
    dateRange = [dayjs(), dayjs()],
    disabled = false,
  }: Props) => {
    return (
      <>
        <div className={styles.incomingCallsTop}>
          <JournalSearchInput onSearch={onSearch} disabled={disabled} />
          <ResettableRangePicker
            className={styles.dateInput}
            value={dateRange}
            placeholder={['Период звонков', 'Период звонков']}
            presets={RANGE_PRESENT}
            onChange={onRangePicker}
            disabled={disabled}
          />

          <JournalActionButtons
            onReport={onOkReport}
            onToggleFilters={onToggleFilters}
            isFiltersOpen={isFiltersOpen}
            isReportLoading={isReportLoading}
            showUpload={false}
            activeFilterCount={activeFilterCount}
            disabled={disabled}
          />
        </div>
      </>
    );
  },
);

IncomingCallsTop.displayName = 'IncomingCallsTop';
